import { WifiOff } from 'lucide-react'

export function OfflineBanner({ isOffline }: { isOffline: boolean }) {
  if (!isOffline) return null
  return (
    <div className="flex items-center justify-center gap-2 bg-red-600 px-4 py-2 text-sm text-white">
      <WifiOff className="h-4 w-4" />
      No connection — write actions are blocked
    </div>
  )
}
